import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const UPDATE_STATEMENT_INTERESTS_HOLD = gql`
  mutation UpdateStatementInterestsHold($uuid: ID!, $request: StatementInterestsHoldInputDto!) {
    updateStatementInterestsHold(uuid: $uuid, request: $request) {
      uuid
      consultantUuid
      startDate
      endDate
      comment
      createdAt
      updatedAt
    }
  }
`;

export const useUpdateStatementInterestsHold = () => {
  const [updateStatementInterestsHold, { loading, error, data }] = useMutation(UPDATE_STATEMENT_INTERESTS_HOLD);

  return {
    updateStatementInterestsHold,
    loading,
    error,
    data: data?.updateStatementInterestsHold,
  };
};

export default useUpdateStatementInterestsHold;
